import React from "react";
import { Toast } from "react-bootstrap";
import { setComponentFlag, componentFlagValue } from "presentation/utils/functions/generic";

class TimesheetStructureTips extends React.Component {
    constructor(props) {
        super(props);

    }
    render() {
        const { component, form } = this.props;


        return (
            <div className="tips-container">
                <Toast
                    onClose={() => setComponentFlag(component, 'deleteTip', false)}
                    show={componentFlagValue(component, 'deleteTip')}
                    delay={6000}
                    autohide
                    position={"top-end"}
                >
                    <Toast.Header className="toast-header-red">
                        <strong className="me-auto">BasicoApp</strong>
                    </Toast.Header>
                    <Toast.Body>Opa! Estruturas de quadro de horário precisam ter ao menos um tempo de atividade</Toast.Body>
                </Toast>
            </div>
        );
    };
}

export default TimesheetStructureTips;


